import type {ItemConfig, ItemLiterals} from '@github-ui/filter-picker'

import {ListItemRepoIcon} from './components/ListItemRepoIcon'
import {reposPickerRepositoriesPath} from './paths'
import type {PickerRepository, PickerScope} from './types'

export const literals: ItemLiterals = {
  itemName: 'repository',
  itemsName: 'repositories',
  listTitle: 'Repositories list',
}

export function getReposItemConfig(scope: PickerScope): ItemConfig<PickerRepository> {
  return {
    literals,
    getSearchUrl: query => reposPickerRepositoriesPath({scope, query}),
    onRenderItemLeadingVisual: repo => <ListItemRepoIcon visibility={repo.visibility} />,
    onRenderItemName: repo => getRepoName(repo, scope.type),
    ...(scope.type === 'unbounded' && {
      initialQuery: 'contributed-by:@me',
      emptyQueryMessage: 'Enter a query to start searching.',
    }),
    isHollow: repo => !repo.name,
  }
}

export function getRepoName(repo: PickerRepository, scopeType: PickerScope['type']) {
  const showRepoOwner = scopeType !== 'organization' && scopeType !== 'user'
  if (showRepoOwner && repo.ownerLogin) {
    return `${repo.ownerLogin}/${repo.name}`
  }
  return repo.name
}
